import { sortOnPriority } from "../ArticlesHelpers";

export class Article {
  constructor(
    id,
    merchant_id,
    allergenIds = [],
    articlegroup_id,
    description,
    modifiergroupIds = [],
    name,
    price,
    priority,
    plu,
    manual_active,
    weight,
    imagePath,
    printTags,
    print_name,
    meta_json,
    max_n,
    menu_tags,
    handheld_only,
    translation_id,
    category,
    description_translation_id,
    is_menu,
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    sunday,
    receipt_priority,
    vat_high,
    vat_json,
    vat_low,
    type,
    active,
    updatedAt,
    handheld_bg_color,
    print_name_2,
    pos_name,
    pos_printer_category,
    min_amount,
    supergroup_tags,
    short_key,
    ledger_account,
    view_only
  ) {
    this.id = id;
    this.name = name;
    this.merchant_id = merchant_id;
    this.allergenIds = allergenIds;
    this.articlegroup_id = articlegroup_id;
    this.description = description;
    this.image = imagePath;
    this.price = price;
    this.priority = priority;
    this.plu = plu;
    this.manual_active = manual_active;
    this.weight = weight;
    this.tag = printTags;
    this.max_n = max_n;
    this.active = active;
    this.handheld_only = handheld_only;
    this.print_name = print_name;
    this.vat_low = vat_low;
    this.vat_high = vat_high;
    this.vat_json = vat_json;
    this.menu_tags = menu_tags;
    this.type = type;
    this.is_menu = is_menu;
    this.category = category;
    this.translation_id = translation_id;
    this.description_translation_id = description_translation_id;
    this.receipt_priority = receipt_priority;
    this.meta_json = meta_json;
    this.modifiergroupIds = modifiergroupIds;
    this.monday = monday;
    this.tuesday = tuesday;
    this.wednesday = wednesday;
    this.thursday = thursday;
    this.wednesday = wednesday;
    this.thursday = thursday;
    this.friday = friday;
    this.saturday = saturday;
    this.sunday = sunday;
    this.updated_at = updatedAt;
    this.handheld_bg_color = handheld_bg_color;
    this.print_name_2 = print_name_2;
    this.pos_name = pos_name;
    this.pos_printer_category = pos_printer_category;
    this.min_amount = min_amount;
    this.supergroup_tags = supergroup_tags;
    this.short_key = short_key;
    this.ledger_account = ledger_account;
    this.view_only = view_only;
  }

  equals(otherObject) {
    function deepEqual(object1, object2) {
      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
          return false;
        }
      }

      return true;
    }

    function isObject(object) {
      return object != null && typeof object === "object";
    }

    if (!otherObject instanceof Article) {
      return false;
    }

    return deepEqual(this, otherObject);
  }

  getModifiergroups(modifiergroups) {
    return sortOnPriority(this.modifiergroupIds.map((modifiergroupId) => modifiergroups[modifiergroupId]));
  }

  getPrintTags() {
    if (this.tag != null) {
      return this.tag.split("|");
    }
    return [];
  }

  getMenuTags() {
    if (this.menu_tags != null) {
      return this.menu_tags.split("|");
    }
    return [];
  }

  getSupergroupTags() {
    if (this.supergroup_tags != null) {
      return this.supergroup_tags.split("|");
    }
    return [];
  }

  get key() {
    return this.id + "-" + this.updated_at;
  }
}

export const CreateArticle = (json, allergenIds, modifiergroupIds) => {
  return new Article(
    json.id,
    json.merchant_id,
    allergenIds,
    json.article.articlegroup_id,
    json.description,
    modifiergroupIds,
    json.article.name,
    json.price,
    json.priority,
    json.plu,
    json.manual_active,
    json.weight,
    json.image,
    json.tag,
    json.print_name,
    json.meta_json,
    json.max_n,
    json.menu_tags,
    json.handheld_only,
    json.translation_id,
    json.category,
    json.description_translation_id,
    json.is_menu,
    json.monday,
    json.tuesday,
    json.wednesday,
    json.thursday,
    json.friday,
    json.saturday,
    json.sunday,
    json.receipt_priority,
    json.vat_high,
    json.vat_json,
    json.vat_low,
    json.type,
    json.active,
    json.updated_at,
    json.handheld_bg_color,
    json.print_name_2,
    json.pos_name,
    json.pos_printer_category,
    json.min_amount,
    json.supergroup_tags,
    json.short_key,
    json.ledger_account,
    json.view_only
  );
};
